module.exports = __webpack_public_path__ + "img/adv_safe.94b23635.png";